module.exports = __webpack_public_path__ + "static/media/rocket.44596141.png";